module.exports = __webpack_public_path__ + "img/b289193.jpg";